type getStylesProps = {
	theme: any;
};
export const getStyles = ({ theme }: getStylesProps) => {
	const textColor = theme.palette.typographyText.textSecondary ?? 'rgba(0, 0, 0, 0.60)';
	return {
		footer: {
			flexWrap: 'nowrap',
		},
		poweredBy: {
			font: 'work-sans',
			color: textColor,
		},
		refineintel: {
			color: textColor,
			overflow: 'none',
		},
		faqButton: {
			justifyContent: 'start',
			padding: '0',
			textDecoration: 'underline',
			fontSize: '13px',
			whiteSpace: 'nowrap',
		},
	};
};
